import type { SelectHTMLAttributes, ReactNode } from 'react';
import styles from './style.module.css';

type Props = SelectHTMLAttributes<HTMLSelectElement> & {
  label?: string;
  hint?: string;
  children: ReactNode;
};

export function Select({ label, hint, className, children, ...rest }: Props) {
  if (!label) {
    return (
      <select className={`${styles.select}${className ? ` ${className}` : ''}`} {...rest}>
        {children}
      </select>
    );
  }

  return (
    <label className={`${styles.field}${className ? ` ${className}` : ''}`}>
      <span className={styles.label}>
        {label}
        {hint && <span className={styles.hint}> {hint}</span>}
      </span>
      <select className={styles.select} {...rest}>
        {children}
      </select>
    </label>
  );
}
